import { render, staticRenderFns } from "./superuser-placeholder-pdf-emails.vue?vue&type=template&id=0bb241ce&"
import script from "./superuser-placeholder-pdf-emails.vue?vue&type=script&lang=js&"
export * from "./superuser-placeholder-pdf-emails.vue?vue&type=script&lang=js&"
import style0 from "./superuser-placeholder-pdf-emails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports